// extracted by mini-css-extract-plugin
export var headingAnimation = "headingAnimation-module--headingAnimation--298a8";
export var headingAnimation__child = "headingAnimation-module--headingAnimation__child--3ac4b";